import { render, staticRenderFns } from "./AppointmentsCompletedChart.vue?vue&type=template&id=3f7817fa&"
import script from "./AppointmentsCompletedChart.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCompletedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports